<template>
  <div class="item">
    <div class="field-narrow">{{ index + 1 }}</div>
    <div class="field-medium">{{ item.name }}</div>
    <div class="field-medium">{{ convertToMacAddress(item.MAC) }}</div>
    <div class="field-medium" v-if="item.id > 0">
      <button type="button" class="btn" @click="updateItem(true)" v-if="type === 0">{{ this.$t('join') }}</button>
      <button type="button" class="btn" @click="updateItem(false)" v-else>{{ this.$t('remove') }}</button>
    </div>
    <div class="field-medium" v-else />
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { inject } from 'vue';
import Swal from 'sweetalert2';
import { fetchGroup } from '../utils/api';

export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
    mainId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n();
    const apiBaseUrl = inject('apiBaseUrl');
    return { t, apiBaseUrl };
  },
  methods: {
    updateItem(add) {
      let title = this.$t('delete');
      let url = '/group_delete/device';
      if (add) {
        title = this.$t('add');
        url = '/group_insert/device';
      }
      Swal.fire({
        icon: 'question',
        title: this.$t('confirm') + title,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
      }).then((result) => {
        let t = title;
        if (result.isConfirmed) {
          try {
            const data = JSON.stringify({ mainId: this.item.id, subId: this.mainId });
            fetchGroup(this.t, `${this.apiBaseUrl}/${url}`, data, null).then((response) => {
              if (response.data.success) {
                if (add) {
                  this.$emit('add-group', this.item);
                } else {
                  this.$emit('remove-group', this.item);
                }
              }
            });
          } catch (error) {
            t += this.$t('failure');
            console.error('Error fetching data:', error);
            Swal.fire({
              title: t,
              icon: 'error',
            });
          }
        }
      });
    },
    convertToMacAddress(longInt) {
      const hex = parseInt(longInt, 10).toString(16).padStart(12, '0');
      return hex.replace(/(.{2})(?=.)/g, '$1:').toUpperCase();
    },
  },
};
</script>

<style>
.item {
  display: flex;
  justify-content: space-between;
  font-weight: normal;
  padding: 10px;
}

.field-narrow {
  flex: 1;
  text-align: center;
}

.field-medium {
  flex: 2;
  text-align: center;
}
</style>
